import React from 'react';
import type { MenuControlScheme, MenuLanguage } from './types.js';

export function ControlSelector({ language, value, sensitivity, onChange, onSensitivityChange }: {
  language: MenuLanguage; value: MenuControlScheme; sensitivity: number;
  onChange: (scheme: MenuControlScheme) => void; onSensitivityChange: (value: number) => void;
}) {
  const es = language === 'es';
  const tr = (s: string, e: string, f: string) => es ? s : language === 'fr' ? f : e;
  return <section className="menu-setting-group">
    <label className="menu-setting"><span>{tr('Controles', 'Controls', 'Commandes')}</span>
      <select value={value} onChange={(event) => onChange(event.target.value as MenuControlScheme)}>
        <option value="mouse">{tr('Ratón', 'Mouse', 'Souris')}</option>
        <option value="wasd">WASD</option>
        <option value="touch">{tr('Táctil', 'Touch', 'Tactile')}</option>
      </select>
    </label>
    <small>{tr('WASD es el control predeterminado en PC y táctil en móvil.', 'WASD is the default on PC and touch on mobile.', 'WASD est utilisé par défaut sur PC et le tactile sur mobile.')}</small>
    <label className="menu-setting menu-slider"><span>{tr('Sensibilidad del ratón', 'Mouse sensitivity', 'Sensibilité de la souris')}</span>
      <input type="range" min="0.5" max="2" step="0.1" value={sensitivity}
        onChange={(event) => onSensitivityChange(Number(event.target.value))} />
    </label>
  </section>;
}
